/**
 * Format pair symbol for Bitget WebSocket
 * Perps: BTC/USDT:USDT → BTCUSDT
 * Spot: BTC/USDT → BTCUSDT
 */
export function formatBitgetInstId(pairSymbol: string): string {
  // Remove settle part (after ":") if present, then remove "/"
  const basePair = pairSymbol.split(":")[0] ?? pairSymbol;
  return basePair.replace("/", "");
}

/**
 * Resolve the Bitget instType from a pair symbol.
 * BTC/USDT       → SPOT
 * BTC/USDT:USDT  → USDT-FUTURES
 * BTC/USDC:USDC  → USDC-FUTURES
 * BTC/USD:BTC    → COIN-FUTURES
 */
export function getBitgetInstType(pairSymbol: string): string {
  const settle = pairSymbol.split(":")[1];
  if (!settle) return "SPOT";
  if (settle === "USDT") return "USDT-FUTURES";
  if (settle === "USDC") return "USDC-FUTURES";
  return "COIN-FUTURES";
}
